// extracted by mini-css-extract-plugin
export default {"button":"add-item-icon_button__8y0IS","button__icon":"add-item-icon_button__icon__j5pfP"};